import React from "react";
import { PartController } from "./PartController";
import { PartViewModel } from "./PartViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class PartProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new PartViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <PartController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Part/PartProvider.js